interface IConfig {
  apiUrl: string
  appDomain: string
  awsRegion: string
  awsUserPoolId: string
  awsUserPoolClientId: string
  awsRedirectSignInUrl: string
  awsUserPoolDomainUrl: string
}

const config: IConfig = {
  apiUrl: import.meta.env.VITE_API_URL || "",
  appDomain: import.meta.env.VITE_APP_DOMAIN || "",
  awsRegion: import.meta.env.VITE_AWS_REGION || "",
  awsUserPoolId: import.meta.env.VITE_AWS_USERPOOL_ID || "",
  awsUserPoolClientId: import.meta.env.VITE_AWS_USER_POOL_CLIENT_ID || "",
  awsRedirectSignInUrl: import.meta.env.VITE_AWS_REDIRECT_SIGNIN_URL || "",
  awsUserPoolDomainUrl: import.meta.env.VITE_AWS_USERPOOL_DOMAIN_URL || "",
}

export default config
